import Vue from 'vue';

Vue.filter('word-ending', (value, variants) => {
  if (!variants || (variants.length !== 3)) {
    return value;
  }
  const cases = [2, 0, 1, 1, 1, 2];
  const i = ((value % 100 > 4) && (value % 100 < 20)) ? 2 : cases[Math.min(value % 10, 5)];
  return variants[i] ? variants[i] : variants[0];
});
